
// Simple toaster component for now
export function Toaster() {
  return (
    <div id="toast-container" className="fixed bottom-4 right-4 z-50">
      {/* Toast notifications will be rendered here */}
    </div>
  );
}
